import type React from 'react';
import { useLayoutEffect, useState } from 'react';

const useGaListPositionCalculation = <T extends Element>(ref: React.RefObject<T | null>) => {
    const [listPosition, setListPosition] = useState<number>();

    useLayoutEffect(() => {
        const lists = document.querySelectorAll('[data-list]');
        const position = Array.from(lists).findIndex((el) => el === ref.current);
        setListPosition(position > -1 ? position : undefined);
    }, [ref]);

    return {
        listPosition,
    };
};

export default useGaListPositionCalculation;
